import { useDispatch } from "react-redux";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  setSelectedDatabase,
  setSelectedId,
  setSelectedModules,
  setSelectedQueryName,
  setSelectedType,
} from "../../../../features/dataStoreReqSlice";

const DataStoreRequestFilter = () => {
  const dispatch = useDispatch();
  const [searchDatabase, setSearchDatabase] = useState("");
  const [searchType, setSearchType] = useState("");
  const [searchId, setSearchId] = useState("");
  const [moduleName, setModuleName] = useState("");
  const {
    selectedDatabase,
    selectedType,
    quaryContent,
    selectedId,
    selectedModules,
  } = useSelector((state: any) => state.dataStoreReq);

  const filterConfig = [
    {
      key: "database",
      label: "Select Database",
      searchTerm: searchDatabase,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchDatabase(e.target.value),
      selectedOption: selectedDatabase,
      filterName: "database",
      data: quaryContent,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedDatabase(updatedSelection)),
      count: selectedDatabase && selectedDatabase.length,
      colorSelected:
        selectedDatabase !== null && selectedDatabase.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "type",
      label: "Select Type",
      searchTerm: searchType,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchType(e.target.value),
      selectedOption: selectedType,
      filterName: "type",
      data: quaryContent,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedType(updatedSelection)),
      count: selectedType && selectedType.length,
      colorSelected:
        selectedType !== null && selectedType.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "id",
      label: "Select Id",
      searchTerm: searchId,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchId(e.target.value),
      selectedOption: selectedId,
      filterName: "id",
      data: quaryContent,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedId(updatedSelection)),
      count: selectedId && selectedId.length,
      colorSelected:
        selectedId !== null && selectedId.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "modules",
      label: "Select Modules",
      searchTerm: moduleName,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setModuleName(e.target.value),
      selectedOption: selectedModules,
      filterName: "modules",
      data: quaryContent,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedModules(updatedSelection)),
      count: selectedModules && selectedModules.length,
      colorSelected:
        selectedModules !== null && selectedModules.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];
  const clearFilters = () => {
    dispatch(setSelectedDatabase([]));
    dispatch(setSelectedType([]));
    dispatch(setSelectedQueryName(""));
    dispatch(setSelectedId([]));
    setSearchDatabase("");
    setSearchType("");
    setSearchId("");
    setModuleName("");
    dispatch(setSelectedModules([]));
  };

  return (
    <>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </>
  );
};

export default DataStoreRequestFilter;
